import React from "react";
import { Route } from "react-router-dom";

import ProtectedRoute from "../components/common/ProtectedRoute";

import AdminDashboard from "../pages/admin/AdminDashboard";
import OrdersPage from "../pages/admin/OrdersPage";
import OrderDetailsPage from "../pages/admin/OrderDetailsPage";
import OrderStatusManager from "../pages/admin/OrderStatusManager";
import PaymentDashboard from "../pages/admin/PaymentDashboard";
import InvoiceDashboard from "../pages/admin/InvoiceDashboard";
import Reports from "../pages/admin/Reports";
import StaffManagement from "../pages/admin/StaffManagement";
import StaffPasswordManagement from "../pages/admin/StaffPasswordManagement";
import AdminVisitReport from "../pages/admin/AdminVisitReport";
import ActivityLogsPage from "../pages/admin/ActivityLogsPage";

import Products from "../pages/admin/Products";
import CreateProduct from "../pages/admin/CreateProduct";
import Categories from "../pages/admin/categories/Categories";
import AddProductImages from "../pages/admin/AddProductImages";
import FirmPage from "../pages/admin/FirmPage";

import LeadsManagement from "../pages/leads/LeadsManagement"; // or shared folder
import LeadDetails from "../pages/leads/LeadDetails";
import AdminLeadAssignment from "../pages/leads/AdminLeadAssignment";
import LeadTimeline from "../pages/leads/LeadTimeline";
import LeadActivity from "../pages/leads/LeadActivity";
import VisitProofs from "../pages/leads/VisitProofs";

const AdminRoutes = () => {
  return (
    <>
      <Route
        path="/admin"
        element={
          <ProtectedRoute role="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/staff"
        element={
          <ProtectedRoute role="admin">
            <StaffManagement />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/staff-password"
        element={
          <ProtectedRoute role="admin">
            <StaffPasswordManagement />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/products"
        element={
          <ProtectedRoute role="admin">
            <Products />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/products/create"
        element={
          <ProtectedRoute role="admin">
            <CreateProduct />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/products/:productId/images"
        element={
          <ProtectedRoute role="admin">
            <AddProductImages />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/categories"
        element={
          <ProtectedRoute role="admin">
            <Categories />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/orders"
        element={
          <ProtectedRoute role="admin">
            <OrdersPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/orders/:id"
        element={
          <ProtectedRoute role="admin">
            <OrderDetailsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/order-status"
        element={
          <ProtectedRoute role="admin">
            <OrderStatusManager />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/payments"
        element={
          <ProtectedRoute role="admin">
            <PaymentDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/firms"
        element={
          <ProtectedRoute role="admin">
            <FirmPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/invoices"
        element={
          <ProtectedRoute role="admin">
            <InvoiceDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/reports"
        element={
          <ProtectedRoute role="admin">
            <Reports />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/leads"
        element={
          <ProtectedRoute role="admin">
            <LeadsManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/leads/:id"
        element={
          <ProtectedRoute role="admin">
            <LeadDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/leads/assign"
        element={
          <ProtectedRoute role="admin">
            <AdminLeadAssignment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/leads/:id/timeline"
        element={
          <ProtectedRoute role="admin">
            <LeadTimeline />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/leads/:id/activity"
        element={
          <ProtectedRoute role="admin">
            <LeadActivity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/leads/activity/:id/proofs"
        element={
          <ProtectedRoute role="admin">
            <VisitProofs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/visit-proofs"
        element={
          <ProtectedRoute role="admin">
            <AdminVisitReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/activity-logs"
        element={
          <ProtectedRoute role="admin">
            <ActivityLogsPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};

export default AdminRoutes;